import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createProductPackagedItem',
    serviceName: 'shopadmin',
    query: gql`
      mutation createProductPackagedItem(
        $title: String!
        $shop_id: String!
        $booth_id: String!
        $brand_id: String
        $category_id: String
        $co_price: String
        $me_price: String
        $stock: String
        $max_number_buy: String
        $nonexistent_number: String
        $discount_value: String
        $is_active: Int
        $introtext: String
        $packaged_items: [PackagedItemInput]!
        $barcode: String
      ) {
        createProductPackagedItem(
          title: $title
          shop_id: $shop_id
          booth_id: $booth_id
          brand_id: $brand_id
          category_id: $category_id
          co_price: $co_price
          me_price: $me_price
          stock: $stock
          max_number_buy: $max_number_buy
          nonexistent_number: $nonexistent_number
          discount_value: $discount_value
          is_active: $is_active
          introtext: $introtext
          packaged_items: $packaged_items
          barcode: $barcode
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
